import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const ECHOCARE_API_BASE_URL = "http://devmusicccare.com:5175/api/v1/";

export const createAppointment = async (appointmentData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/appointments`, appointmentData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data; 
    } catch (error) {
        console.error("Error creating appointment:", error.response?.data || error.message);
        throw error;
    }
};

export const listAppointments = async (params = {}) => {
  try {
    console.log("MY APPOINTMENT SERVICE FILE LOADED");
    const response = await axios.get(`${API_BASE_URL}/appointments`, {
        
      params: {
        user_id: params.user_id,    
        dr_id: params.dr_id,      
        status: params.status,
        date: params.date
      }
      
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching appointments:", error.response?.data || error.message);
    throw error;
  }
};

// export const listViewAppointments = async () => {
//     try {
//         const response = await axios.get(`${API_BASE_URL}/veiwappointments`);
//         return response.data;
//     } catch (error) {
//         console.error("\u274c Error fetching view appointments:", error);
//         throw error;
//     }
// };

export const listViewAppointments = async (doctorId) => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const token = user.token || '';
        const response = await axios.get(`${API_BASE_URL}/veiwappointments`, {
            params: {
                doctor_id: doctorId
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching view appointments:", error.response?.data || error.message);
        throw error;
    }
};

export const submitReview = async (reviewData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/reviews`, reviewData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error submitting review:", error.response?.data || error.message);
        throw error;
    }
};

export const getAllAppointments = async (params = {}) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/all-appointments`, {
            params: {
                start_date: params.start_date,
                end_date: params.end_date,
                user_id: params.user_id
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching all appointments:", error.response?.data || error.message);
        throw error;
    }
};

export const cancelAppointment = async (appointmentId, remark = '', triggeredBy = 'counsellor') => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const token = user.token || '';
        const response = await axios.patch(`${API_BASE_URL}/appointments/${appointmentId}`, 
            { status: 'cancelled', cancellation_remark: remark, cancellation_triggered_by: triggeredBy },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error cancelling appointment:", error.response?.data || error.message);
        throw error;
    }
};

export const decrementBookedAppointment = async (customerId) => {

  try {

    const response = await axios.patch(
      `${ECHOCARE_API_BASE_URL}echocare/decrement-booked-appointment/${customerId}`
    );

    return response.data;

  } catch (error) {

    console.error(
      "Error decrementing booked appointment:",
      error.response?.data || error.message
    );

    throw error;
  }
};

export const updateSessionState = async (appointmentId, { customer_state, counsellor_state }) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const token = user.token || '';
    const body = {};
    if (customer_state !== undefined) body.customer_state = customer_state;
    if (counsellor_state !== undefined) body.counsellor_state = counsellor_state;
    const response = await axios.patch(
        `${API_BASE_URL}/appointments/${appointmentId}/call-status`,
        body,
        { headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" } }
    );
    return response.data;
};

// Get appointments by doctor ID
export const updateAudioCallStatus = async (appointmentId, audioCallStatus) => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const token = user.token || '';
        const response = await axios.patch(
            `${API_BASE_URL}/appointments/${appointmentId}/call-status`,
            { call_status: audioCallStatus },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating audio call status:", error.response?.data || error.message);
        throw error;
    }
};

// Get appointments by doctor ID
export const getAppointmentsByDoctorID = async (doctorId) => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const token = user.token || '';

        const response = await axios.get(
            `${API_BASE_URL}/appointments/doctor/${doctorId}`,
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "Error fetching doctor appointments:",
            error.response?.data || error.message
        );
        throw error;
    }
};

// Get appointments by patient/customer ID
export const getAppointmentsByPatientID = async (
  patientId,
  doctorId
) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/appointments/patient/${patientId}`,
      {
        params: {
          doctor_id: doctorId
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Get today's appointments by doctor ID
export const getTodayAppointmentsByDoctorID = async (doctorId) => {
    try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const token = user.token || "";

        const response = await axios.get(
            `${API_BASE_URL}/appointments/doctor/${doctorId}/today`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data.data || [];
    } catch (error) {
        console.error(
            "Error fetching today's appointments:",
            error.response?.data || error.message
        );
        throw error;
    }
};

// Get upcoming appointments by doctor ID
export const getUpcomingAppointmentsByDoctorID = async (doctorId) => {
    try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const token = user.token || "";

        const response = await axios.get(
            `${API_BASE_URL}/appointments/doctor/${doctorId}/upcoming`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data.data || [];
    } catch (error) {
        console.error(
            "Error fetching upcoming appointments:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const updateTransactionStatus = async (
    appointmentId,
    transactionStatus
) => {
    try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const token = user.token || "";

        const response = await axios.patch(
            `${API_BASE_URL}/appointments/${appointmentId}/transaction-status`,
            {
                transaction_status: transactionStatus
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "Error updating transaction status:",
            error.response?.data || error.message
        );

        throw error;
    }
};